import { render } from "./TheGame.vue?vue&type=template&id=dcdf7208"
import script from "./TheGame.vue?vue&type=script&lang=js"
export * from "./TheGame.vue?vue&type=script&lang=js"

import "./TheGame.vue?vue&type=style&index=0&id=dcdf7208&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__